var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductRelated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.40025 9.82734C3.84806 7.02792 3.57197 5.62821 4.16938 4.48936C4.76678 3.35052 6.05072 2.82894 8.61861 1.78579L9.14185 1.57323C11.0819 0.785144 12.0519 0.391099 12.6373 0.899995C13.2227 1.40889 13.0165 2.46685 12.6041 4.58278L10.7674 14.0052H5.22432L4.40025 9.82734Z",
    stroke: "#2177FE",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00024 16.5078C3.00024 15.3293 3.00024 14.74 3.36636 14.3739C3.73248 14.0078 4.32173 14.0078 5.50024 14.0078L10.5002 14.0078C11.6788 14.0078 12.268 14.0078 12.6341 14.3739C13.0002 14.74 13.0002 15.3293 13.0002 16.5078V17.3411H3.00024V16.5078Z",
    stroke: "#2177FE",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 17.3359L14.6668 17.3359",
    stroke: "#2177FE",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductRelated);
export default __webpack_public_path__ + "static/media/ProductRelated.9b91360132735a636a4814f511074824.svg";
export { ForwardRef as ReactComponent };